import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { SketchPicker as Picker } from 'react-color'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import PaletteIcon from '@material-ui/icons/Palette'
import Button from 'components/theme/Button'
import { paste } from 'actions/template'

const ColorPickerTool = ({ view }) => {
  const [showPicker, setShowPicker] = useState(false)
  const [color, setColor] = useState('#000000')
  const pickerRef = useRef(null)

  const handleColorChange = (color) => {
    setColor(color.hex)
  }

  const handleConfirm = () => {
    setShowPicker(false)
    const { state, dispatch } = view
    const { schema } = state

    const markType = schema.marks.style

    if (markType) {
      const { tr } = state
      const { from, to } = state.selection
      tr.addMark(from, to, markType.create({ style: `color: ${color}` }))
      dispatch(tr.scrollIntoView())
    }
  }

  // Close the color picker when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [pickerRef])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Tooltip title="Font Color">
        <IconButton
          onClick={() => setShowPicker(!showPicker)}
          style={{ padding: 6 }}
        >
          <PaletteIcon />
        </IconButton>
      </Tooltip>
      {showPicker && (
        <div
          ref={pickerRef}
          style={{
            position: 'absolute',
            zIndex: 1000,
            background: '#fff',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            top: '40px', // Position below the button
            left: '50%',
            transform: 'translateX(-50%)',
            boxSizing: 'border-box',
            width: 'max-content'
          }}
        >
          <Picker
            color={color}
            onChange={handleColorChange}
          />
          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
            <Button color="primary" onClick={handleConfirm}>Confirm</Button>
            <Button onClick={() => setShowPicker(false)}>Cancel</Button>
          </div>
        </div>
      )}
    </div>
  )
}

const ConnectedColorPickerTool = connect(
  null,
  dispatch => bindActionCreators({ paste }, dispatch),
)(ColorPickerTool)

export default ConnectedColorPickerTool
